import PromotionCarousel from './PromotionCarousel';

export default PromotionCarousel;
